import { render, staticRenderFns } from "./ModalValueHelp.vue?vue&type=template&id=0dcbba39&"
import script from "./ModalValueHelp.vue?vue&type=script&lang=js&"
export * from "./ModalValueHelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports